import * as actionTypes from './actionTypes';
import { combineReducers } from 'redux';
import { map, reject } from 'lodash';

const checksInitialState = {
  response: null,
  error: null,
  isLoading: false,

  record: null,
  recordError: null,
};

export const checksReducer = (state = checksInitialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CHECKS: {
      return { ...state, isLoading: true, error: null };
    }

    case actionTypes.FETCH_CHECKS_SUCCESS: {
      return { ...state, isLoading: false, response: action.payload };
    }

    case actionTypes.FETCH_CHECKS_FAILURE: {
      return { ...state, isLoading: false, error: action.error };
    }

    case actionTypes.UPDATE_CHECK: {
      const { id, delta } = action.payload;

      const nextData = map(state.response.content, (item) => {
        if (id === item.receiptId) {
          return { ...item, ...delta };
        }

        return item;
      });

      return { ...state, response: { ...state.response, content: nextData } };
    }

    case actionTypes.DELETE_CHECK: {
      const { id } = action.payload;

      const nextData = reject(state.response.content, { receiptId: id });

      return { ...state, response: { ...state.response, content: nextData } };
    }

    case actionTypes.START_RECORD_PROCESS: {
      return { ...state, record: action.payload, recordError: null };
    }

    case actionTypes.ERROR_RECORD_PROCESS: {
      return { ...state, recordError: action.payload };
    }

    case actionTypes.FINISH_RECORD_PROCESS: {
      return { ...state, record: null };
    }

    default:
      return state;
  }
};

const filtersInitialState = {
  categories: null,
  years: null,

  error: null,
  isLoading: false,
};

export const filtersReducer = (state = filtersInitialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FILTERS: {
      return { ...state, isLoading: true, error: null };
    }

    case actionTypes.FETCH_FILTERS_SUCCESS: {
      return { ...state, isLoading: false, ...action.payload };
    }

    case actionTypes.FETCH_FILTERS_FAILURE: {
      return { ...state, isLoading: false, error: action.error };
    }

    default:
      return state;
  }
};

const dictionariesInitialState = {
  pending: 0,

  categories: [],
};

export const dictionariesReducer = (state = dictionariesInitialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DICTIONARIES_CATEGORIES: {
      return { ...state, pending: state.pending + 1 };
    }

    case actionTypes.FETCH_DICTIONARIES_CATEGORIES_SUCCESS: {
      return { ...state, pending: state.pending - 1, categories: action.payload };
    }

    default:
      return state;
  }
};

export default combineReducers({
  checks: checksReducer,
  filters: filtersReducer,
  dictionaries: dictionariesReducer,
});
